import React, { Component, Suspense } from "react";
import edit from "../image/icons/edit.png"
import plus from "../image/icons/plus.png"
import * as ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import $ from 'jquery'
const folderName = window.sessionStorage.getItem("homeName");

export default class BannerBottom extends Component {

    constructor(props) {
    super(props);
    this.state = {
      missionData: [],
      parentName:'',
      missionSubList: [],
      sectionName:'Mission'
    };
  }
  addClick (sid,pId,cId,psubTitle,cTitile,cdescri,childUrl,childImg,sOrder) {
    if($("#missionParentId").val()!=""){
      pId=$("#missionParentId").val();
    }
    if(childImg){
      var splitImg=childImg.split("theme/")
      childImg=splitImg[1];
      }
    const LazyPage = React.lazy(() => import("../" + folderName + "/ThemeComponent"));
    ReactDOM.render(
      <div>
        <Suspense fallback={<div>Loading...</div>}>
          <section>
            <LazyPage  sessionId={sid} 
            parentId={pId}
            childId={cId}
            patentTitle={this.state.parentName}
            childTitle={cTitile}
            parentSubTitle={psubTitle}
            childDesri={cdescri}
            sectionName={this.state.sectionName}
            childUrl={childUrl}
            childImg={childImg}
            sortSubOrder={sOrder}
            />
          </section>
        </Suspense>
      </div>,
      document.getElementById("missionpopUpBlock")
    );
    $("#missionpopUpBlock").addClass('editActive');
  }
  componentDidMount() {
    const missionData = JSON.parse(window.sessionStorage.getItem("Mission"));
    // console.log(missionData);
    if (missionData) {
      this.setState({ missionData: missionData });
      this.setState({ parentName: missionData[0].parentName })
      this.setState({ missionSubList: missionData[0].sectionList });
    } else {
      //window.location.reload(false);
    }
  }

  render() {
    return (
      <div class="featured-content mb-5 dashContent" >
        {/* {this.state.missionSubList.map((ban, index) => {
              return ( */}
        <h4 class="mainHead">{this.state.parentName!= '' ? this.state.parentName : 'Book An Appointment'}</h4>
      {/* //   );
      // })} */}
        {this.props.themeFlag === "theme" && (
        <div className="editIconSec" id="Mission">
         <span className="editIcon editAddIcon" title="Add" onClick={() => this.addClick("15","","","","","","","","")}><img src={plus} alt="Add"/></span>
          </div>
          )}
          <div className="cmsContentDiv dashContent" id="missionpopUpBlock"></div>        
            <input type="hidden" id="missionSectionId" value="15"/>
            <div className="featuredMain">
            {this.state.missionData.map((data) => {
                return (
                <div>  
              <input type="hidden" id="missionParentId" value={data.parentId} />
              {data.sectionList.length != "0" && (
              <div>
              {data.sectionList.map((ban, index) => {
              return (
              <div class="featuredList">
                    {this.props.themeFlag === "theme" && (
                    <div className="editIconSec editIconSecTop">
                      <span className="editIcon editAddIcon" title="Edit" onClick={() => this.addClick
                        (data.sectionId,
                          data.parentId,
                        ban.childId,
                        data.parentSubTitle,
                        ban.childName,
                        ban.childDescription,
                        ban.childUrl,
                        ban.childImage,
                        ban.homeAdsSubSortOrder)}><img src={edit} alt="logo"/></span>
                      </div>
                        )}
                  <a href={ban.childUrl} >
                    <div class="featuredIcon">
                    <span>
                      <img src={ban.childImage} alt="" />
                    </span>
                    </div>
                    {ban.childName!="@" ? (
                    <div class="featuredHead"> {ban.childName}</div>
                    ) : ''}
                  </a>
              </div>
              );
              })}
              </div>
              )}
            </div>
                );
              })}
{/*               
              <div class="featuredList featuredListBtn">
                <span class="borderBtn">Find More</span>
              </div> */}
            </div>
      </div>
    );
  }
}
